var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlugCircleCheck = function SvgPlugCircleCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.4 2.7v-.3h-.6v4.2h.6zm6.6 0v-.3h-.6v4.2h.6zM1.5 7.8h-.3v.6h1.5v3a5.7 5.7 0 0 0 5.4 5.693V21.6h.6v-4.507a5.7 5.7 0 0 0 2.111-.525 6 6 0 0 1-.003-.671A5.1 5.1 0 0 1 3.3 11.4v-3h10.2v2.474c.19-.142.393-.273.6-.393V8.4h1.5v-.6H1.5m15.9 3.6a4.8 4.8 0 1 1 0 9.6 4.8 4.8 0 0 1 0-9.6m0 10.2a5.4 5.4 0 1 0 0-10.8 5.4 5.4 0 0 0 0 10.8m2.824-6.9-.424-.423-.214.213-2.786 2.787-1.586-1.587-.214-.213-.424.423.214.214 1.8 1.8.214.214.214-.214 3-3 .213-.214z"
  })));
};
export default SvgPlugCircleCheck;